import React, { useState } from 'react';

const TraceEntry = ({ entry, index }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="debug-trace__entry">
            <div className="debug-trace__entry-header" onClick={() => setIsOpen(!isOpen)}>
                <i className={`fas fa-chevron-${isOpen ? 'down' : 'right'} debug-trace__chevron`}></i>
                <span className="debug-trace__tool-name">{entry.name}</span>
                {entry.duration_ms != null && (
                    <span className="debug-trace__duration">{entry.duration_ms}ms</span>
                )}
            </div>
            {isOpen && (
                <div className="debug-trace__entry-body">
                    <div className="debug-trace__section">
                        <div className="debug-trace__section-label">Args</div>
                        <pre className="debug-trace__json">{
                            typeof entry.args === 'string' ? entry.args : JSON.stringify(entry.args, null, 2)
                        }</pre>
                    </div>
                    {entry.response != null && (
                        <div className="debug-trace__section">
                            <div className="debug-trace__section-label">Response</div>
                            <pre className="debug-trace__json">{
                                typeof entry.response === 'string' ? entry.response : JSON.stringify(entry.response, null, 2)
                            }</pre>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export const DebugTracePanel = ({ toolTrace }) => {
    const [isOpen, setIsOpen] = useState(false);

    if (!toolTrace || toolTrace.length === 0) return null;

    return (
        <div className="debug-trace">
            <div className="debug-trace__header" onClick={() => setIsOpen(!isOpen)}>
                <i className="fas fa-bug debug-trace__icon"></i>
                <span>Tool Trace ({toolTrace.length} calls)</span>
                <i className={`fas fa-chevron-${isOpen ? 'up' : 'down'} debug-trace__toggle`}></i>
            </div>
            {isOpen && (
                <div className="debug-trace__body">
                    {toolTrace.map((entry, idx) => (
                        <TraceEntry key={idx} entry={entry} index={idx} />
                    ))}
                </div>
            )}
        </div>
    );
};
